import get from 'lodash/get';
import moment from 'moment';

const bookingDocumentsTypes = {
    bookingForm: 'Formulaire(s) de reservation remplis',
    contract: 'Contrat de réservation à faire signer',
    contractSigned: 'Contrat de résa. contre-signé : ADV',
    contractCounterSigned: 'Contrat de résa. contre-signé: Prescripteur',
    dgAttestation: 'Justificatif versement DG (Maxi J+11)',
    loanResquestAttestation: 'Attestation de demande de prêt (Maxi J+30)',
    financingAgreement: 'Accord de financement (Maxi J+60)',
    loanOfferSigned: 'Offre de prêt signée (Maxi J+90)',
    propertyAttestation: 'Attestation de propriété AVEC PRIX (Maxi J+90)',
    transferProof: 'Preuve de virement',
    invoiceDocument: 'Facture Prescripteur',
    promoterDirectInvoice: "Facture Promoteur",


    invoiceRearMargin: 'Facture Marge Arr. PlugIMMO'
};

function formatBookingDocumentsTypes(value: string) {
    return get(bookingDocumentsTypes, value, value);
}

function formatBookingDocumentsTypesFileName(bookingCode: string, value: string) {
    return `${bookingCode}_${get(bookingDocumentsTypes, value, value)}_${moment().format('DDMMYYYY')}`;
}

export { bookingDocumentsTypes, formatBookingDocumentsTypes, formatBookingDocumentsTypesFileName };
